"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAMS_APP_SLUG = exports.MEMBERS_APP_SLUG = void 0;
exports.MEMBERS_APP_SLUG = "members";
exports.TEAMS_APP_SLUG = "teams";
